import Vue from 'vue'
import axios from 'axios'
import es6Promise from 'es6-promise'
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';

es6Promise.polyfill()
require('es6-promise/auto');
new Vue({
    el: '#aerCardApp',
    components: {
        VueHcaptcha
    },
    data: {
        Name: null,
        AerCardId: null,
        Message: 'You have successfully linked your Aer Credit Card with your AerClub account.',
        formErrors: [],
        Congratulations: 'Congratulations',
        MemberShipDate: null,
        username: null,
        password: null,
        mobilePhone: null,
        phonePrefix: null,
        phoneFormErrors: [],
        codeFormErrors: [],
        BOIId: null,
        isLoggedIn: false,
        needsSMSVerification: false,
        mobileCodeLogin: false,
        standardLogin: false,
        codedigit1: null,
        codedigit2: null,
        codedigit3: null,
        codedigit4: null,
        HashedID: null,
        loading: false,
        HasCookie: false,
        spinnerColor: '#5dc596',
        spinnerSize: '145px',
        spinnerMargin: '120px',
        spinnerRadius: '100%',
        surname: '',
        hCaptchaToken: '',
        hCaptchaFailed: false
    },
    computed: {
        formErrorType: function () {
            return this.formErrors[0] === 'The password and/or email address you entered is incorrect. Please try again.';
        },
        phoneErrorNoNumber: function () {
            return this.phoneFormErrors[0] === 'Phone Number required.';
        },
        phoneErrorInvalidNumber: function () {
            return this.phoneFormErrors[0] === 'Invalid Number Entered';
        },
    },

    methods: {
        onVerify(token) {
            this.hCaptchaToken = token;
            this.hCaptchaFailed = false;
        },
        onExpired() {
            this.hCaptchaToken = '';
        },
        move: function (e) {
            var value = e.target.value;
            if (value != '' && value != null && value != undefined) {
                e.target.nextElementSibling.classList.add('moved');
            } else {
                e.target.nextElementSibling.classList.remove('moved');
            }
        },

        Login: function Login(event) {
            if (!this.hCaptchaToken) {
                this.hCaptchaFailed = true;
                this.loading = false;
                return;
            }

            this.loading = true;
            this.formErrors = [];
            var loginModel = {
                UserName: this.username,
                Password: this.password,
                BOIID: this.BOIId,
                CaptchaToken: this.hCaptchaToken
            }
            axios.post(getControllerUrl('AerCardLogin', 'Account'), {
                model: loginModel
            })
                .then(response => {
                    this.loading = false;
                    if (response.data.isLoggedIn == true) {
                        if (response.data.standardLogin == true) {
                            var memberUrl = getControllerUrl('Members', 'Home');
                            window.location.href = memberUrl;
                        } else {
                            this.isLoggedIn = response.data.isLoggedIn;
                            this.Name = response.data.Name;
                            this.AirCardId = response.data.AerCardId;
                            this.Message = response.data.message;
                            this.needsSMSVerification = response.data.needsSMSVerification;
                            this.surname = response.data.surname;                          
                        }

                    } else {
                        console.log(response)
                        this.formErrors = [];
                        console.log(response)
                        this.formErrors.push(response.data.message);

                        this.hCaptchaToken = "";
                        this.$refs.captcha.reset();

                        if (response.data.captchaValidationFailed == true) {
                            this.hCaptchaFailed = true;                          
                        }
                        
                    }
                })
                .catch(function (e) {
              this.loading = false;
               // this.errors.push(e);
                })
        },
        getVerifyCode: function getVerifyCode(event) {
            this.loading = true;
            this.phoneFormErrors = [];
            axios.post(getControllerUrl('GetCode', 'Account'), {
                mobilePhone: this.mobilePhone,
                phonePrefix: this.phonePrefix
            })
                .then(response => {
                    this.loading = false;
                    if (response.data.Sent == true) {
                        this.isLoggedIn = false;
                        this.HashedID = response.data.HashedID;
                        this.BOIId = response.data.Token;
                        this.mobileCodeLogin = true;
                    } else {
                        this.phoneFormErrors = [];
                        this.phoneFormErrors.push(response.data.message);
                    }
                })
                .catch(function (e) {
                    this.loading = false;
                    // this.errors.push(e);
                })
        },
        getQueryVariable: function getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return pair[1]; }
            }
            return (false);
        },
        onSubmit: function (e) {
            this.loading = true;
            this.formErrors = [];
            if (this.username && this.password) {
                this.Login();
            } else {
                this.loading = false;
                this.formErrors = [];
                if (!this.username) this.formErrors.push("Username required.");
                if (!this.password) this.formErrors.push("Password is required.");


            }
        },
        getVerifyCodeCheck: function (e) {
            this.phoneFormErrors = [];
            if (this.mobilePhone != null) {
                this.getVerifyCode();
            } else {
                this.phoneFormErrors = [];
                if (!this.mobilePhone) this.phoneFormErrors.push("Phone Number required.");

            }
        },
        setCookie: function () {
            var cname = "cookie-policy-updated"
            var cvalue = "1"
            var d = new Date();
            var year = d.getFullYear();
            var month = d.getMonth();
            var day = d.getDate();
            var c = new Date(year + 1, month, day)
            var expires = "expires=" + c.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";secure;path=/";
        },
        checkCookie: function () {
            var user = this.getCookie("cookie-policy-updated");
            if (user == "") {
                this.setCookie();
            } else {
                this.HasCookie = true;
            }
        },
        getCookie: function (cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        codeCheck: function codeCheck(event) {
            this.loading = true;
            this.codeFormErrors = [];
            var codeModel = {
                codedigit1: this.codedigit1,
                codedigit2: this.codedigit2,
                codedigit3: this.codedigit3,
                codedigit4: this.codedigit4,
                HashedID: this.HashedID,
                BOIID: this.BOIId,
                AerCardId: this.AirCardId,
                Surname: this.surname
            }; 

            axios.post(getControllerUrl('LinkAccountUsingCode', 'Account'), {
                model: codeModel
            })
                .then(response => {
                    this.loading = false;
                    if (response.data.Success == true) {
                        this.isLoggedIn = response.data.isLoggedIn,
                            this.Name = response.data.Name,
                            this.surname = response.data.surname
                            this.AirCardId = response.data.AerCardId,
                            this.Message = response.data.message,
                            this.needsSMSVerification = response.data.needsSMSVerification,
                            this.mobileCodeLogin = false

                    } else {
                        this.codeFormErrors = [];
                        this.codeFormErrors.push("Code not recognised");
                    }
                })
                .catch(function (e) {
                    this.loading = false;
                    console.log(e.response);
                })
        }
    },
    beforeMount: function () {
        var id = this.getQueryVariable('id');
        this.checkCookie();
        console.log(id);
        if (id != false)
            this.BOIId = id;

    },
    mounted: function () {
        document.querySelectorAll('.container .flex-header:nth-child(1)')[0].style.marginTop = '1.5rem';
        $('.background-container__img').css('display', 'block');
        $('.background-container__img--grad').css('display', 'block');
        $('.validation-error-icon').tooltip({
            template: '<div class="tooltip" style="background-color:#e5615d"><div class="tooltip-arrow tooltip-arrow-b" style="border-top-color:#e5615d"></div><div style="background-color:#e5615d" class="tooltip-inner"></div></div>'
        });
        $('body').css('background', 'white');
        $('#username').click();

        //var el = this.$el.getElementsByClassName('test')[0];
        //var el2 = this.$el.getElementsByClassName('test')[1];
        //const autoFillClass = 'moved',
        //    onAutoFillStart = (el) => el.nextElementSibling.classList.add(autoFillClass),
        //    onAutoFillCancel = (el) => el.nextElementSibling.classList.remove(autoFillClass),
        //    onAnimationStart = ({ target, animationName }) => {
        //        switch (animationName) {
        //            case 'onAutoFillStart':
        //                return onAutoFillStart(target)
        //            case 'onAutoFillCancel':
        //                return onAutoFillCancel(target)
        //        }
        //    }
        //el.addEventListener('animationstart', onAnimationStart, false)
        //el2.addEventListener('animationstart', onAnimationStart, false)
    }
})


// WEBPACK FOOTER //
// ./app/loggedin/index.js